package music.jammers.client.shared.analytics.event

import music.jammers.client.shared.analytics.FirebaseAnalytics

interface EventAnalytics {

    fun onError(throwable: Throwable)
    fun onEventCreated(id: Long)
    fun onEventClicked(id: Long)
    fun onAcceptMember(id: Long)
    fun onSignInSuccess(id: Long)
    fun onCancelMember(id: Long)
    fun onSignOutSuccess(id: Long)
}

internal class EventAnalyticsImpl(
    private val firebaseAnalytics: FirebaseAnalytics,
) : EventAnalytics {

    override fun onError(throwable: Throwable) {
        firebaseAnalytics.logEvent("event_error") {
            val value = throwable.message ?: throwable.toString()
            param("reason", value.take(VALUE_LIMIT))
        }
    }

    override fun onEventCreated(id: Long) {
        firebaseAnalytics.logEvent("event_created") {
            param("eventId", id)
        }
    }

    override fun onEventClicked(id: Long) {
        firebaseAnalytics.logEvent("event_list_card_clicked") {
            param("eventId", id)
        }
    }

    override fun onAcceptMember(id: Long) {
        firebaseAnalytics.logEvent("event_member_accept_clicked") {
            param("memberId", id)
        }
    }

    override fun onSignInSuccess(id: Long) {
        firebaseAnalytics.logEvent("event_member_accepted") {
            param("memberId", id)
        }
    }

    override fun onCancelMember(id: Long) {
        firebaseAnalytics.logEvent("event_member_cancel_clicked") {
            param("memberId", id)
        }
    }

    override fun onSignOutSuccess(id: Long) {
        firebaseAnalytics.logEvent("event_member_cancelled") {
            param("memberId", id)
        }
    }

    private companion object {

        const val VALUE_LIMIT = 40
    }
}